import React, { createElement, createRef, forwardRef, useState } from "react";
import { Keyboard, StyleSheet, Platform, TouchableOpacity, View } from "react-native";
import { TextInput, Modal, theme, ITextInput } from "ui-components";
import DateTimePicker from "@react-native-community/datetimepicker";
import moment from "moment";
import { TouchableOpacity as TouchableOpacityGesture } from "react-native-gesture-handler";
import { format } from "date-fns";
import Auryc from "rn-auryc-sdk";

interface DatePickerDropdownNewProps extends ITextInput {
  minimumDate?: Date;
  maximumDate?: Date;
  formName?: string;
  onChange: Function | any;
  errors?: any;
  inputAccessoryViewID?: string;
  onSubmitEditing?: any;
  title?: string;
  date?: any;
}

export const DatePickerDropdownNew = forwardRef((props: DatePickerDropdownNewProps, ref: any) => {
  const {
    minimumDate,
    maximumDate,
    formName,
    errors,
    onChange,
    inputAccessoryViewID,
    onSubmitEditing,
    title,
    date,
  } = props;
  const [showPicker, setShowPicker] = useState<boolean>(false);

  const [value, setValue] = useState<any>(date);
  const [valueForWeb, setValueForWeb] = useState<any>(date);
  const styles = getStyles();
  const modalRef = createRef();
  const TouchableComponent =
    Platform.OS == "android" || Platform.OS == "web" ? TouchableOpacity : TouchableOpacityGesture;
  const selectValueLabel = value ? format(value, "MM/dd/yyyy") : "";

  const onDatePick = (event: any, selectedDate: Date) => {
    if (Platform.OS == "web") {
      selectedDate = moment(event.target.value).toDate();
      if (new Date(selectedDate) >= minimumDate && new Date(selectedDate) <= maximumDate) {
        setValue(selectedDate);
        setValueForWeb(event.target.value);
        onChange && onChange(selectedDate);
      }
    } else {
      setShowPicker(Platform.OS === "ios");
      setValue(selectedDate);
      onChange && onChange(selectedDate);
    }
  };

  return (
    <View ref={(x) => Auryc.unMarkViewAsSensitiveInformation(x)}>
      <TouchableComponent
        disabled={props.disabled}
        activeOpacity={0.8}
        onPress={() => {
          modalRef?.current?.open();
          setShowPicker(true);
        }}
        style={{ outlineStyle: "none" }}
        testID={props.testID + "-button"}
        accessibilityLabel={props.accessibilityLabel + " button"}>
        <TextInput
          labelStyle={{ fontFamily: "Lato_700Bold" }}
          label={title}
          value={selectValueLabel}
          leftIconColor={theme.colors.primary}
          leftIcon={"calendar"}
          error={errors?.formName}
          inputAccessoryViewID={inputAccessoryViewID}
          onSubmitEditing={onSubmitEditing}
          placeholder={"mm/dd/yyyy"}
          ref={ref}
          editable={false}
          {...props}
        />
      </TouchableComponent>

      {Platform.OS == "android" ? (
        showPicker && (
          <DateTimePicker
            style={styles.picker}
            value={moment(value).toDate()}
            mode={"date"}
            minimumDate={minimumDate}
            maximumDate={maximumDate}
            display={"default"}
            onChange={onDatePick}
            testID={props.testID || props.accessibilityLabel + "date-time-picker"}
            accessibilityLabel={props.accessibilityLabel || props.testID + "date-time-picker"}
          />
        )
      ) : (
        <Modal
          ref={modalRef}
          showCloseIcon={true}
          containerStyle={{ maxWidth: 400 }}
          testID={props.testID || props.accessibilityLabel + "date-time-picker-modal-container"}>
          {Platform.OS == "web" ? (
            createElement("input", {
              type: "date",
              value: new Date(valueForWeb).toISOString().split("T")[0],
              onInput: onDatePick,
              min: new Date(minimumDate).toISOString().split("T")[0],
              max: new Date(maximumDate).toISOString().split("T")[0],
              readonly: true,
            })
          ) : (
            <DateTimePicker
              textColor={theme.colors.darkBackgroundText}
              style={styles.picker}
              value={moment(value).toDate()}
              mode={"date"}
              minimumDate={minimumDate}
              maximumDate={maximumDate}
              display={Platform.OS === "ios" ? "spinner" : "default"}
              onChange={onDatePick}
              testID={props.testID || props.accessibilityLabel + "date-time-picker"}
              accessibilityLabel={props.accessibilityLabel || props.testID + "date-time-picker"}
            />
          )}
        </Modal>
      )}
    </View>
  );
});

const getStyles = () => {
  return StyleSheet.create({
    modalContainer: {
      borderRadius: 10,
    },
    picker: {
      width: "100%",
      padding: 15,
    },
    textInput: {},
  });
};
